<template>
  <Delete
    resource="documents"
    dispatch="documentStore/delete"
    routing="Documents"
    :id="id"
  ></Delete>
</template>

<script>
import Delete from "../common/tabs/Delete";
export default {
  name: "DeleteDocument",
  props: ["id"],
  components: { Delete }
};
</script>

<style scoped></style>
